// Dose Volume Histogram (DVH) data model
export class Dvh {
    public readonly dvhData: number[]; // DVH data, amount of cumulated structure volume at each bin
    public readonly binWidth: number; // Width of each bin in Gy
    public readonly maxDose: number; // Maximum dose in Gy
    public readonly minDose: number; // Minimum dose in Gy
    public readonly meanDose: number; // Mean dose in Gy

    constructor(
        dvhData: number[],
        binWidth: number,
        maxDose: number,
        minDose: number,
        meanDose: number
    ) {
        this.dvhData = dvhData;
        this.binWidth = binWidth;
        this.maxDose = maxDose;
        this.minDose = minDose;
        this.meanDose = meanDose;
    }
}
